// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"f5df4c7a","116":"04b19409","186":"135ffabc","362":"067362fc","409":"dc954429","423":"0593ce96","467":"28c8c2df","505":"352d8e91","516":"29bbd0b2","565":"55951980","657":"bbad31e3","722":"cd75e250","807":"71904205","815":"4fa99200","978":"62132f78","981":"be939f25"}[chunkId] + ".chunk.js";
};